import {Inject, Injectable} from "@angular/core";

@Injectable()
export class UiServiceProvider {
  public ShowInformation(info: string) {
    let proxy = this.window["ShowInformation"];
    if (proxy !== undefined) {
      proxy.postMessage(info);
    }
  }

  public ShowMessage(message: string) {
    let proxy = this.window["ShowMessage"];
    if (proxy !== undefined) {
      proxy.postMessage(message);
    }
  }

  constructor(@Inject('Window') private window: any) {
    this.window.console.error = (text) => {
      this.ShowInformation(text);
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/ui-service/ui-service.ts